import { render, staticRenderFns } from "./viewBalance.vue?vue&type=template&id=3ff9da1c&scoped=true&"
import script from "./viewBalance.vue?vue&type=script&lang=js&"
export * from "./viewBalance.vue?vue&type=script&lang=js&"
import style0 from "./viewBalance.vue?vue&type=style&index=0&id=3ff9da1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9da1c",
  null
  
)

export default component.exports